import React, { useState, useEffect } from 'react';
import accountService from '../services/accountService';

const ChainContactTab = ({ accountId }) => {
    const [formData, setFormData] = useState({
        CONTACTNAME:  '',
        CONTACTEMAIL: '',
        CONTACTPHONE: '',
        CONTACTMOBILE: '',
    });
    const [loading, setLoading] = useState(true);
    const [saving, setSaving]   = useState(false);
    const [error, setError]     = useState(null);
    const [savedMsg, setSavedMsg] = useState(null);

    useEffect(() => {
        if (!accountId) return;
        setLoading(true);
        accountService.getAccountById(accountId)
            .then(data => {
                const a = data?.account || data;
                setFormData({
                    CONTACTNAME:  a.contactName  || a.CONTACTNAME  || '',
                    CONTACTEMAIL: a.contactEmail || a.CONTACTEMAIL || '',
                    CONTACTPHONE: a.contactPhone || a.CONTACTPHONE || '',
                    CONTACTMOBILE: a.contactMobile || a.CONTACTMOBILE || '',
                });
            })
            .catch(err => setError(err.response?.data?.message || 'Failed to load chain'))
            .finally(() => setLoading(false));
    }, [accountId]);

    const handleChange = (e) => setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSaving(true);
        setError(null);
        setSavedMsg(null);
        try {
            await accountService.updateAccount(accountId, formData);
            setSavedMsg('Saved.');
            setTimeout(() => setSavedMsg(null), 3000);
        } catch (err) {
            setError(err.response?.data?.message || err.message || 'Failed to save');
        } finally {
            setSaving(false);
        }
    };

    if (loading) return <div className="tab-content"><div style={{ padding: '1rem', color: '#6b7280' }}>Loading…</div></div>;

    return (
        <div className="tab-content">
            <form onSubmit={handleSubmit}>
                <div className="form-section">
                    <h3>Contact Information</h3>
                    {error && <div className="error-message" style={{ marginBottom: '1rem' }}>{error}</div>}
                    {savedMsg && <div style={{ marginBottom: '1rem', padding: '0.5rem 0.75rem', background: '#ecfdf5', border: '1px solid #6ee7b7', borderRadius: '6px', color: '#065f46' }}>{savedMsg}</div>}
                    <div className="form-row">
                        <div className="form-group">
                            <label htmlFor="CONTACTNAME">Contact Name</label>
                            <input id="CONTACTNAME" name="CONTACTNAME" type="text" value={formData.CONTACTNAME} onChange={handleChange} />
                        </div>
                        <div className="form-group">
                            <label htmlFor="CONTACTEMAIL">Contact Email</label>
                            <input id="CONTACTEMAIL" name="CONTACTEMAIL" type="email" value={formData.CONTACTEMAIL} onChange={handleChange} />
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-group">
                            <label htmlFor="CONTACTPHONE">Contact Phone</label>
                            <input id="CONTACTPHONE" name="CONTACTPHONE" type="text" value={formData.CONTACTPHONE} onChange={handleChange} />
                        </div>
                        <div className="form-group">
                            <label htmlFor="CONTACTMOBILE">Contact Mobile</label>
                            <input id="CONTACTMOBILE" name="CONTACTMOBILE" type="text" value={formData.CONTACTMOBILE} onChange={handleChange} />
                        </div>
                    </div>
                    <div style={{ marginTop: '1rem' }}>
                        <button type="submit" className="btn-primary" disabled={saving}>{saving ? 'Saving…' : 'Save'}</button>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default ChainContactTab;
